import _ from "lodash";
export const IS_USER_ACCESS_PAGE = (controller, action) => {
	let isUserHasRights = false, isEditAccess = false;
	let loginData = JSON.parse(localStorage.getItem("user_information"));
	let isSuperAdmin = loginData && loginData && loginData.user_data && (loginData.user_data.role_id === -1 || loginData.user_data.role_id.includes(-1) || loginData.user_data.role_id.includes(1));
	let is_super_admin = loginData && loginData.user_data && (loginData.user_data.role_id?.includes(-1))
	let is_admin = loginData && loginData.user_data && (loginData.user_data.role_id?.includes(1))
	if (isSuperAdmin) {
		isUserHasRights = true;
		isEditAccess = true;
	} else {
		const userAccessFeatures = JSON.parse(localStorage.getItem("userAccess"));
		if (userAccessFeatures && userAccessFeatures.length) {
			let isKeyExist = _.findKey(userAccessFeatures, function (v) {
				if (controller && v.controller && action && v.action) {
					return (
						v.controller.toLowerCase() === controller.toLowerCase() && 
						v.action.toLowerCase() === action.toLowerCase()
					);
				}
			});
			isUserHasRights = isKeyExist ? true : false;
			isEditAccess = isKeyExist ? ((Number(userAccessFeatures[isKeyExist].access_type) === 1) ? true : false) : false
		}
	}
	if(controller === 'UpdateLead' && loginData && loginData.data && loginData.data.user_data && loginData.data.user_data.user_id === 16){
		isEditAccess = true
		isUserHasRights = true 
	} 

	if(controller === 'UpdateLead' && loginData && loginData.data && loginData.data.user_data && loginData.data.user_data.user_id === 16){
		isEditAccess = true
		isUserHasRights = true 
	}


	return {
		is_access_page: isEditAccess,
		is_edit_access: isUserHasRights,
		is_super_admin: is_super_admin,
		is_admin: is_admin,
	};

	// return {
	// 	is_access_page: isUserHasRights,
	// 	is_edit_access: isEditAccess
	// };
};

export const CHECK_ASSIGN_USER = (assign_to) => {
	let loginData = JSON.parse(localStorage.getItem('user_information'));
	let isSuperAdmin = loginData?.role_id?.includes(-1) || loginData?.role_id?.includes(1);
	if(isSuperAdmin) return false;
	return !(assign_to===loginData?.id);
};

export const IF_ROLES={
	'ops_verifier':7,
	'credit_appraisal':8,
	'credit_ops':9,
	'ops_user':10,
	'auditor': 33,
};

export const API_TIMEOUT=12000;
export const DIF_VAT=1;

export const OPSEE_DOC_IDS = {
	'runner_holding_bpkb': 2,
	'bpkb_personal_data': 3,
	'bpkb_car_data': 4,
	'bpkb_detailed_documents': 5,
	'upload_handover_document': 10,
	'upload_handover_proof': 11,
};

export const numberFormat = (str) => {
    str = str ? str.toString() : "0";
    return str.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');;
}


export const getDaysDifference = (startDate, endDate) => {
    const oneDay = 24 * 60 * 60 * 1000;
    const startMillis = startDate.getTime();
    const endMillis = endDate.getTime();
    const differenceMillis = endMillis - startMillis;
    const differenceDays = differenceMillis / oneDay;
    return parseInt(differenceDays);
}

export const getInspectionScore = (masterData,leadDetail) => {
	let exteriorScore = 0;
    let equipmentAccessoriesScore = 0;
    let interiorScore = 0;
    let mechanicalScore = 0;
    let otherScore = 0;
    masterData?.inspection_attributes?.filter((v)=>+v.id === 1)[0]?.child?.forEach((field) => {
        let score = leadDetail?.lead_inspection?.filter((v)=>+v.attributes_id === +field.id)[0]?.value
        exteriorScore += score
    })
    let exteriorScorePercent = (exteriorScore/22*20).toFixed(2)
    masterData?.inspection_attributes?.filter((v)=>+v.id === 4)[0]?.child?.forEach((field) => {
        let score = leadDetail?.lead_inspection?.filter((v)=>+v.attributes_id === +field.id)[0]?.value
        equipmentAccessoriesScore += score
    })
    let equipmentAccessoriesPercent = (equipmentAccessoriesScore/26*10).toFixed(2)
    masterData?.inspection_attributes?.filter((v)=>+v.id === 2)[0]?.child?.forEach((field) => {
        let score = leadDetail?.lead_inspection?.filter((v)=>+v.attributes_id === +field.id)[0]?.value
        interiorScore += score
    })
    let interiorScorePercent = (interiorScore/14*20).toFixed(2)
    masterData?.inspection_attributes?.filter((v)=>+v.id === 3)[0]?.child?.forEach((field) => {
        let score = leadDetail?.lead_inspection?.filter((v)=>+v.attributes_id === +field.id)[0]?.value
        mechanicalScore += score
    })
    let mechanicalScorePercent = (mechanicalScore/10*30).toFixed(2)
    masterData?.inspection_attributes?.filter((v)=>+v.id === 5)[0]?.child?.forEach((field) => {
        let score = leadDetail?.lead_inspection?.filter((v)=>+v.attributes_id === +field.id)[0]?.value
        otherScore += score
    })
    let otherScorePercent = (otherScore/22*20).toFixed(2)

	return {exteriorScorePercent,equipmentAccessoriesPercent,interiorScorePercent,mechanicalScorePercent,otherScorePercent}
}

// ─── Collateral Grading Config ──────────────────────────────────────────────

export const GRADING_MAX_TOTAL = 70;

export const GRADING_CRITERIA = [
    {
        key: 'age',
        label: 'Age of Vehicle',
        max: 15,
        locked: true,
        bands: [
            { label: '0 – 3 years',    score: 15 },
            { label: '4 – 6 years',    score: 10 },
            { label: '7 – 9 years',    score: 6  },
            { label: '10 – 15 years',  score: 2  },
            { label: 'Over 15 years',  score: 0 }, // DECLINE
        ],
    },
    {
        key: 'mileage',
        label: 'Mileage',
        max: 10,
        locked: false,
        bands: [
            { label: 'Under 20,000 km',         score: 10 },
            { label: '20,000 – 50,000 km',      score: 8  },
            { label: '50,000 – 100,000 km',     score: 6  },
            { label: '100,000 – 150,000 km',    score: 4  },
            { label: 'Over 150,000 km',          score: 2  },
        ],
    },
    {
        key: 'brand',
        label: 'Brand & Model Reputation',
        max: 15,
        locked: true,
        bands: [
            { label: 'Toyota / Honda / Mitsubishi / Nissan',         score: 15   },
            { label: 'Isuzu / Mazda / Suzuki',                       score: 12   },
            { label: 'Hyundai / MG / Geely',                         score: 9    },
            { label: 'Kia / Ford',                                   score: 6    },
            { label: 'Commercial vehicle',                           score: 2    },
            { label: 'Luxury brands (BMW, Mercedes, Audi, Lexus)',   score: 0 },
            { label: 'No-go / unclassified brands',                  score: 0 },
        ],
    },
    {
        key: 'physical',
        label: 'Physical Condition',
        max: 15,
        locked: false,
        bands: [
            { label: 'Good (minor wear, fully functional)',          score: 15   },
            { label: 'Fair (noticeable wear, minor fixes needed)',    score: 8    },
            { label: 'Poor (severe damage, neglect, possible signs of being flooded)',          score: 0 },
        ],
    },
    {
        key: 'mechanical',
        label: 'Mechanical Condition',
        max: 15,
        locked: false,
        bands: [
            { label: 'No issues, fully functional',   score: 15   },
            { label: 'Minor Repairs needed',                         score: 5    },
            { label: 'Major Repairs needed',                         score: 0 },
        ],
    },
];

// Brand name → grading score (lowercase key). 0 = DECLINE.
export const GRADING_BRAND_SCORE_MAP = {
    toyota: 15, honda: 15, mitsubishi: 15, nissan: 15,
    isuzu: 12, mazda: 12, suzuki: 12,
    hyundai: 9, mg: 9, geely: 9,
    kia: 6, ford: 6,
    bmw: 0, mercedes: 0, 'mercedes benz': 0, 'mercedes-benz': 0,
    jeep: 0, volkswagen: 0, audi: 0, peugeot: 0,
    jaguar: 0, subaru: 0, dodge: 0, lexus: 0,
    gac: 0, chery: 0, chevrolet: 0, wuling: 0, photon: 0
};

export const getAgeScore = (makeYear) => {
    if (!makeYear) return 0;
    const age = new Date().getFullYear() - +makeYear;
    if (age <= 3)  return 15;
    if (age <= 6)  return 10;
    if (age <= 9)  return 6;
    if (age <= 15) return 2;
    return 0;
};

export const getAgeBand = (makeYear) => {
    if (!makeYear) return '—';
    const age = new Date().getFullYear() - +makeYear;
    if (age <= 3)  return '0 – 3 years';
    if (age <= 6)  return '4 – 6 years';
    if (age <= 9)  return '7 – 9 years';
    if (age <= 15) return '10 – 15 years';
    return 'Over 15 years';
};

export const getBrandScore = (makeName) => {
    if (!makeName) return 0;
    const key = makeName.toLowerCase().trim();
    if (Object.prototype.hasOwnProperty.call(GRADING_BRAND_SCORE_MAP, key)) {
        return GRADING_BRAND_SCORE_MAP[key];
    }
    return 2; // default: commercial / unrecognised brand
};

export const getBrandBand = (makeName) => {
    const score = getBrandScore(makeName);
    if (score === 0)  return 'Luxury / No-go brand';
    if (score === 15) return 'Toyota / Honda / Mitsubishi / Nissan';
    if (score === 12) return 'Isuzu / Mazda / Suzuki';
    if (score === 9)  return 'Hyundai / MG / Geely';
    if (score === 6)  return 'Kia / Ford';
    return 'Commercial / Other';
};

// total is always numeric (0–70); null means not all criteria selected yet
// Grade buckets based on raw drawdown score (max 70)
export const getCollateralGrade = (total) => {
    if (total === null) return { letter: '—', label: 'Incomplete', ltv: '—',       color: '#98a1b0', bg: '#f1f3f6' };
    if (total >= 65)   return { letter: 'A', label: 'Strong',      ltv: '80 – 85%', color: '#1f9d57', bg: '#e7f6ee' };
    if (total >= 56)   return { letter: 'B', label: 'Acceptable',  ltv: '70 – 80%', color: '#1f9d57', bg: '#e7f6ee' };
    if (total >= 46)   return { letter: 'C', label: 'Marginal',    ltv: '60 – 70%', color: '#b45309', bg: '#fff7eb' };
    if (total >= 40)   return { letter: 'D', label: 'Caution',     ltv: '50 – 60%', color: '#b45309', bg: '#fff7eb' };
    return               { letter: 'E', label: 'Decline',      ltv: 'Decline',   color: '#dc2626', bg: '#fdeeed' };
};

// ─── Deductions Config ───────────────────────────────────────────────────────

export const LUXURY_BRANDS = new Set([
    'bmw', 'mercedes benz', 'mercedes-benz', 'jeep', 'volkswagen',
    'audi', 'peugeot', 'jaguar', 'subaru', 'dodge', 'lexus',
]);

export const getVehicleCategory = (makeName) => {
    if (!makeName) return 'mass_market';
    return LUXURY_BRANDS.has(makeName.toLowerCase().trim()) ? 'sports_luxury' : 'mass_market';
};

export const DEFECT_CATALOG = {
    mass_market: [
        { defect: 'Deep Scratches',                      amount: 10000 },
        { defect: 'Deep Scratch with Dents',             amount: 17500 },
        { defect: 'Misalignment of Gaps',                amount: 10000 },
        { defect: 'Panel Damage',                        amount: 22500 },
        { defect: 'Interior Damage',                     amount: 17500 },
        { defect: 'Power Window Defect',                 amount: 7500  },
        { defect: 'Power Mirror Defect',                 amount: 7500  },
        { defect: 'Wiper Defect',                        amount: 3000  },
        { defect: 'Windshield Damage',                   amount: 21500 },
        { defect: 'Tire Wearability',                    amount: 26000 },
        { defect: 'ABS Issue',                           amount: 25000 },
        { defect: 'SRS Airbag Issue',                    amount: 50000 },
        { defect: 'Electronic Power Steering Issue',     amount: 37500 },
        { defect: 'Odometer Tampering',                  amount: 0, no_cost: true },
        { defect: 'Engine Issue (Minor Repair)',          amount: 45000 },
        { defect: 'Engine Issue (Major Overhaul)',        amount: 105000 },
        { defect: 'Engine Replacement',                  amount: 225000 },
    ],
    sports_luxury: [
        { defect: 'Deep Scratches',                      amount: 27500 },
        { defect: 'Deep Scratch with Dents',             amount: 40000 },
        { defect: 'Misalignment of Gaps',                amount: 27500 },
        { defect: 'Panel Damage',                        amount: 65000 },
        { defect: 'Interior Damage',                     amount: 60000 },
        { defect: 'Power Window Defect',                 amount: 20000 },
        { defect: 'Power Mirror Defect',                 amount: 20000 },
        { defect: 'Wiper Defect',                        amount: 10000 },
        { defect: 'Windshield Damage',                   amount: 75000 },
        { defect: 'Tire Wearability',                    amount: 95000 },
        { defect: 'ABS Issue',                           amount: 65000 },
        { defect: 'SRS Airbag Issue',                    amount: 125000 },
        { defect: 'Electronic Power Steering Issue',     amount: 100000 },
        { defect: 'Engine Issue (Minor Repair)',          amount: 175000 },
        { defect: 'Engine Issue (Major Overhaul)',        amount: 375000 },
        { defect: 'Engine Replacement',                  amount: 750000 },
    ],
};

export const REDRAW_TABLE = [
    { days: '0 – 90 days',         pct: 0,    risk: 'Low Risk',          nogo: false },
    { days: '91 – 120 days',       pct: 10,   risk: 'Moderate Risk',     nogo: false },
    { days: '121 – 150 days',      pct: 15,   risk: 'Elevated Risk',     nogo: false },
    { days: '151 – 180 days',      pct: 20,   risk: 'High Risk',         nogo: false },
    { days: 'More than 180 days',  pct: null, risk: 'Unacceptable Risk', nogo: true  },
];

export const AUTH_KEY="reflnaprv-e1b2519c-4648-4a24-b2dc-86fc7616d24a"

export const FCI_IF_ACCESS_ROLE = 27;
export const FCI_CF_ACCESS_ROLE = 28;
export const FCI_ADMIN_ACCESS_ROLE = 29;

export const CREDIT_APPRAISAL_STATUS = {
	REQUESTED:17,
	WITHDRAWN:18,
	APPRAISED:19
}